<template>
  <div>
  <div v-if='toggledGroup.group' class="flex-none flex flex-row h-12 py-1 overflow-x-auto">
    <button v-for='type in toggledGroup.types'
            @click='changeType(type)'
            class='flex-none h-8 w-20 mr-1 focus:outline-none text-xs rounded'
            :class='classes(type)'
            :key="type.name">
      {{type.name}}
    </button>

  </div>
  <div class="flex-none flex flex-row h-12 py-1 overflow-x-auto">
      <div v-for='group in groupedTypes'
           :key='group.group'
           class="quick-animations-groups flex-none mr-1">

        <button class='w-16'
                :class='groupClass(group)'
                @click='toggleGroup(group)'>{{group.group}}</button>

      </div>

  </div>
  </div>
</template>
<script>
import { cloneDeep, groupBy, toPairs } from 'lodash';

const quickTweensByName = {};

import allAvailableQuicktweens from '@edit/tree/quicktweens.js';
allAvailableQuicktweens.forEach( (quicktween) => {
  quickTweensByName[quicktween.name] = quicktween;
});

import { types } from '@/edit/tree/componentsdb.js';

const availableTypes = [
  {
    name:"Move Left", type:"automove", data:{
      dx:-6, dy:0
    }, group: 'Move'
  },
  {
    name:"Move Right", type:"automove", data:{
      dx:6, dy:0
    }, group: 'Move'
  },
  {
    name:"Move Up", type:"automove", data:{
      dx:0, dy:-6
    }, group: 'Move'
  },
  {
    name:"Move Down", type:"automove", data:{
      dx:0, dy:6
    }, group: 'Move'
  },
  {
    name:"Pulse", type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Zoom In'], {from:1, to:1.2 })
      ]
    }, group: 'Animate'
  },
  {
    name:"Press", type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Zoom Out'], {from:1, to:0.8 })
      ]
    }, group: 'Animate'
  },
  {
    name:"Flip", type:"tween",
    data:{
      tweens:[
        {
          property: 'scaleglobalx',
          from: 1,
          to: -1,
          tween: 'linear',
        }
      ]
    }, group: 'Animate'
  },
  {
    name:"Fade", type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Fade Out'], {from:1, to:0.2 })
      ]
    }, group: 'Animate'
  },
  {
    name:"Slide Left and Right",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Slide In Left'], {from:0, to:3})
      ]
    }, group: 'Slide'
  },
  {
    name:"Slide Right and Left",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Slide In Right'], {from:3, to:0})
      ]
    }, group: 'Slide'
  },
  {
    name:"Bounce",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Slide In Bottom'], {from:0, to:-3})
      ]
    }, group: 'Bounce'
  },
  {
    name:"Bungy Top",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Slide In Top'], {from:0, to:3})
      ]
    }, group: 'Bounce'
  },
  {
    name:"Rotate Left",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Rotate Left'], {
          to: -45,
          tween:'easeInQuad',
        })
      ]
    }, group: 'Rotate'
  },
  {
    name:"Rotate Right",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[
        Object.assign({}, quickTweensByName['Rotate Right'], {
          to: 45,
          tween:'easeInQuad',
        })
      ]
    }, group: 'Rotate'
  },
  {
    name:"Squish",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[{
        property: 'scaleglobaly',
        from: 1,
        to: 0.4,
        tween: 'easeOutCubic'
      }]
    }, group: 'Squish'
  },
  {
    name:"Squish Horizontal",
    type:"tween",
    data:{
      loop:false,
      flip:true,

      tweens:[{
        property: 'scaleglobalx',
        from: 1,
        to: 0.4,
        tween: 'easeOutCubic'
      }]
    }, group: 'Squish'
  },
  {
    name:"Full Rotate Left",
    type:"tween",
    data:{
      loop:false,
      flip:false,

      tweens:[
        Object.assign({}, quickTweensByName['Rotate Left'], {})
      ]
    }, group: 'Rotate'
  },
  {
    name:"Full Rotate Right",
    type:"tween",
    data:{
      loop:false,
      flip:false,

      tweens:[
        Object.assign({}, quickTweensByName['Rotate Right'], {})
      ]
    }, group: 'Rotate'
  },


]
export default {
  props:{
    component:{
      type:Object,
      required:true
    }
  },
  methods:{
    toggleGroup(group) {
      if (this.toggledGroup.group !== group.group) {
        this.toggledGroup = group;
      } else {
        this.toggledGroup = {};
      }
    },
    changeType({name,type,data}) {
      const ov = cloneDeep(this.component);

      const attrs = types[type].createNew();
      Object.assign(attrs, data);
      attrs.__quick = name;
      Object.assign(this.component, attrs);
      this.$emit('change-type', name);
      this.$set(this.component, '__quick', name);

      const nv = this.component;
      this.$emit('change', {ov,nv});
    },
    classes(type) {
      return this.component.__quick === type.name ? "quick-animation-button-selected" : "quick-animation-button";
    },
    groupClass(group) {
      console.log('alpers', group);

      const isGroupSelected = this.toggledGroup.group === group.group; //? "outline-button-selected" : "outline-button"'
      const groupHasSelectedType = group.types.filter( (type) => {
        return this.component.__quick === type.name;
      }).length > 0;
      return isGroupSelected ? "outline-button-selected" : (groupHasSelectedType ? "outline-button animation-group-used" : "outline-button")
    },
  },
  data() {
    if (!this.component.__quick && this.component.__animator !== 'enter' && this.component.__animator !== 'exit') {
      this.$set(this.component, '__quick', '');
      this.changeType(availableTypes[0]);
    }

    const groupedTypes = toPairs(groupBy(availableTypes, 'group')).map( ([group,types]) => {
      return {
        group,
        types
      }
    });

    let toggledGroup = {};
    const firstGroupWithSelection = groupedTypes.filter( (group) => {
      return group.types.filter( (type) => {
        return this.component.__quick === type.name;
      }).length > 0;
    });
    console.log('firstGroupWithSelection', firstGroupWithSelection);
    if (firstGroupWithSelection.length) {
      toggledGroup = firstGroupWithSelection[0];
    }

    return {
      availableTypes,
      groupedTypes,
      toggledGroup
    }
  },
  watch:{
    component() {
      if (!this.component.__quick) {
        this.$set(this.component, '__quick', '');
        this.changeType(this.availableTypes[0]);
      }
      const firstGroupWithSelection = this.groupedTypes.filter( (group) => {
        return group.types.filter( (type) => {
          return this.component.__quick === type.name;
        }).length > 0;
      });
      console.log('firstGroupWithSelection', firstGroupWithSelection);
      if (firstGroupWithSelection.length) {
        this.toggledGroup = firstGroupWithSelection[0];
      }
    }
  }
  
}
</script>
